var cibFlattr = ["32 32", "<path d='M2.541 16c0-7.421 6.037-13.459 13.459-13.459 0.063 0 5.339 0 7.271 0l-3.896 3.907 1.792 1.792 8.036-8.24h-13.203c-8.839 0-16 7.161-16 16v12.443l2.547-2.349v-0.124c-0.005-0.329-0.005-9.876-0.005-9.969zM32 3.557l-2.547 2.349v0.124l0.005 9.969c0 7.421-6.037 13.459-13.459 13.459-0.063 0-5.339 0-7.271 0l3.896-3.907-1.792-1.792-8.036 8.24h13.203c8.839 0 16-7.161 16-16z'/>"];

export { cibFlattr };

